module.exports = __webpack_public_path__ + "static/media/table-no-data-img.77e91bdc.png";